var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShakeyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 107,
    viewBox: "0 0 117 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33008 73.2375C2.33008 73.2375 15.3282 78.5964 23.3794 76.9028C31.4307 75.2092 31.3328 76.5722 33.8482 75.2478C36.3637 73.9234 41.8076 69.6728 45.0735 69.834C48.3395 69.9952 57.7904 68.2686 60.2003 68.3248C62.6101 68.3809 69.4626 66.788 68.2526 62.5391C67.0426 58.2902 53.9502 58.6614 45.166 58.8772C36.3642 59.0852 33.2692 55.6833 33.2692 55.6833",
    stroke: "#555555",
    strokeWidth: 1.60108,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9883 42.8672L44.1127 47.8974C44.1127 47.8974 42.705 56.8886 44.0078 58.597",
    stroke: "#555555",
    strokeWidth: 1.60108,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1123 47.8981C44.1123 47.8981 48.6561 50.6801 52.7479 49.7786L54.9981 46.1543",
    stroke: "#555555",
    strokeWidth: 1.60108,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7695 49.7861C52.7695 49.7861 54.712 53.448 59.829 55.4546L52.7695 49.7861Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7695 49.7861C52.7695 49.7861 54.712 53.448 59.829 55.4546",
    stroke: "#555555",
    strokeWidth: 1.60108,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8906 50.7369C43.8906 50.7369 46.2692 52.2904 47.907 52.3837C49.5449 52.4769 52.4212 53.4735 52.7078 54.2506C52.9945 55.0278 52.9299 58.6931 52.9299 58.6931",
    stroke: "#555555",
    strokeWidth: 1.60108,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0757 52.0443L52.7031 54.2508",
    stroke: "#555555",
    strokeWidth: 1.1798,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8468 49.9327C64.8468 49.9327 59.0894 44.1184 57.8118 42.4002C56.5343 40.682 48.683 39.0219 43.8185 38.1553C38.954 37.2886 33.7359 34.6078 32.3263 34.6153C30.9168 34.6229 20.2959 37.7639 20.2959 37.7639",
    stroke: "#555555",
    strokeWidth: 1.60108,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M109.374 74.551C109.72 74.8965 110.28 74.8965 110.626 74.551L116.257 68.9198C116.602 68.5743 116.602 68.014 116.257 67.6684C115.911 67.3229 115.351 67.3229 115.005 67.6684L110 72.6739L104.995 67.6684C104.649 67.3229 104.089 67.3229 103.743 67.6684C103.398 68.014 103.398 68.5742 103.743 68.9198L109.374 74.551ZM110.626 24.0717C110.28 23.7261 109.72 23.7261 109.374 24.0717L103.743 29.7029C103.398 30.0484 103.398 30.6087 103.743 30.9542C104.089 31.2998 104.649 31.2998 104.995 30.9542L110 25.9487L115.005 30.9542C115.351 31.2998 115.911 31.2998 116.257 30.9542C116.602 30.6087 116.602 30.0484 116.257 29.7029L110.626 24.0717ZM110.885 73.9253V24.6974H109.115V73.9253H110.885Z",
    fill: "#D9808A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2949 40.157C74.9058 37.1503 79.4598 36.8297 82.4668 39.4402L83.0098 39.9119C86.017 42.5226 86.3382 47.0765 83.7275 50.0837L49.4004 89.6238C46.8712 92.5364 42.518 92.9297 39.5146 90.5779L39.2285 90.3416L38.6855 89.8699C35.6787 87.2594 35.3569 82.7052 37.9668 79.698L46.7422 69.573L47.3418 69.4978L49.3633 69.2429L39.3008 80.8542H39.2998C37.3286 83.1253 37.5711 86.5651 39.8418 88.5369L40.3857 89.0085C42.6568 90.9802 46.0966 90.7373 48.0684 88.4666L82.3955 48.9265C84.367 46.6553 84.1246 43.2155 81.8535 41.2439L81.3096 40.7722C79.0384 38.8008 75.5987 39.0432 73.627 41.3142V41.3152L58.0312 59.2478L57.6924 59.2283L55.8076 59.1169L72.2949 40.157Z",
    fill: "#555555"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3214 48.8255L94.1331 39.8276C95.3508 38.5864 96.1461 36.2498 97.2145 35.0192C98.2829 33.7885 96.7751 32.6197 96.7751 32.6197L92.5878 28.9844L91.9325 28.4155L87.7451 24.7802C87.7451 24.7802 86.3761 23.4515 85.3077 24.6822C84.2393 25.9128 82.0376 27.0284 80.9798 28.4083L73.1819 37.3903C73.1819 37.3903 71.3743 38.9882 73.0045 40.4034L77.8471 44.6076C78.2467 44.9545 78.5024 45.1765 78.5024 45.1765L83.345 49.3807C84.9911 50.8098 86.3033 48.7818 86.3033 48.7818L86.3214 48.8255Z",
    fill: "#9E8959"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.09 31.2158L80.4746 42.2915",
    stroke: "white",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4566 29.5776L77.0205 39.2948",
    stroke: "white",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3472 35.5576L83.9111 45.2748",
    stroke: "white",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShakeyIcon);
export default __webpack_public_path__ + "static/media/shakey-icon.9d6e0d88830bc3e5f8f81e443244640a.svg";
export { ForwardRef as ReactComponent };